export default __webpack_public_path__ + "static/media/gl_4.49954998.png";